<template>
    <b-popover
        :target="target"
        triggers="click"
        placement="top"
        @shown="shown"
    >
        <template v-slot:title>
            <div class="row">
                <div class="col"></div>
                <div class="col-auto">
                    <button class="btn btn-white btn-sm" @click="pickColor(null)">
                        {{$t("No variations")}}
                    </button>
                </div>
            </div>
        </template>
        <div class="row">
            <div class="col-2" v-for="color in colors" :key="color">
                <div @click="pickColor(color)"
                     class="pointer text-center border rounded square"
                     :style="'background-color:' + color">
                </div>
            </div>
        </div>
    </b-popover>
</template>

<script>
    export default {
        name: "ColorPopover",
        props: {
            value: String,
            target: String,
            set: Function
        },
        components: {},
        data() {
            return {
                colors: [
                    '#FF9CBB',
                    '#E2A6E6',
                    '#A5DFF8',
                    '#BBC1E8',
                    '#a663cc',
                    '#f4a261'
                ]
            }
        },
        methods: {
            close() {
                this.$root.$emit('bv::hide::popover');
            },

            pickColor(color) {
                this.set(color)
                this.close();
            },

            shown() {
            }
        }
    }
</script>

<style scoped lang="scss">
    .popover {
        width: 300px;
    }

    .square {
        width: 30px;
        height: 30px
    }
</style>
